import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ContractDetailsButtonWrapper" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContractDetailsModal = _resolveComponent("ContractDetailsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "NavigatorButton ContractDetailsButton",
      title: "Check contract details",
      disabled: !_ctx.canOpen,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showContractDetails()))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "lnr-document" }, null, -1 /* CACHED */)
    ]), 8 /* PROPS */, _hoisted_2),
    (_ctx.contractDetailsModalShown)
      ? (_openBlock(), _createBlock(_component_ContractDetailsModal, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ]))
}